// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22EUN","title":"styles_title__3aSP3"};